module.exports = __webpack_public_path__ + "static/media/grupo.68185beb.svg";